export default "/kiban/_next/static/images/top_orange-8bc0bfa3253d41e064039840e982f17a.png";